import { baseStyleSheet } from '../../../../web/styles/styles';
import { styleSheet } from './styles';
import { StyleDeclarationValue, css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';

interface IProps {
	className?: string;
	children?: string[];
	image?: React.ReactNode;
	onClick?(): void;
	styles?: StyleDeclarationValue[];
	title?: string;
}

class _ToolsCard extends React.Component<IProps> {
	public render() {
		const { className, styles, image, onClick, children, title } = this.props;
		return (
			<div
				className={`${css(styleSheet.container, ...(styles || []))} tools-card ${className || ''}`}
				onClick={onClick}
			>
				<div className={css(styleSheet.image)}>{image}</div>
				<div className={css(styleSheet.divider)} />
				{!!title && <div className={css(styleSheet.title, baseStyleSheet.truncateText)}>{title}</div>}
				<ul className={css(styleSheet.description)}>
					{(children || []).map((x, i) => {
						return <li key={`${x}-${i}`}>{x}</li>;
					})}
				</ul>
			</div>
		);
	}
}

export const ToolsCard = observer(_ToolsCard);
